"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientStatusSchemaProperties = exports.ClientStatusSchema = exports.ClientStatusGroupEnum = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const getZodHexString = () => zod_1.z.string().regex(/^#[0-9A-F]{6}$/i, "Must be a valid hex color");
const ClientStatusStyleSchema = zod_1.z.object({
    text: getZodHexString(),
    background: getZodHexString(),
});
exports.ClientStatusGroupEnum = zod_1.z.enum([
    "pre-pipeline",
    "pre-purchase",
    "lost",
    "qualified",
    "customer",
    "churn",
]);
exports.ClientStatusSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    styles: ClientStatusStyleSchema,
    group: exports.ClientStatusGroupEnum,
    order: zod_1.z.number(),
});
exports.ClientStatusSchemaProperties = {
    collectionName: "clientStatuses",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=client-status-schema.js.map